import { Injectable } from "@angular/core";
import { AuthService } from "@evc/platform";
import { lastValueFrom } from "rxjs";
import { AppInfoSchema } from "../_offline/models/app-info.schema";
import { AppInfoDbService } from "./database/app-info-db.service";
import { ElectronService } from "../electron.service";
import { NetworkStatusService } from "./network-status.service";
import { RoutePage } from "../app-routes.enum";

@Injectable({ providedIn: "root" })
export class AppModeInitService {
  constructor(
    private authService: AuthService,
    private appInfoDbService: AppInfoDbService,
    private electronService: ElectronService,
    private networkStatusService: NetworkStatusService
  ) {}

  async initMode(): Promise<void> {
    const isWebApp = !this.networkStatusService.isDesktop();

    if (isWebApp) {
      this.authService.isOffline.set(false);
      return;
    }

    const isCancelLogin = document.location.pathname === `/${RoutePage.CancelLogin}`;
    const hasInternetConnection = await this.electronService.checkInternetConnectivity();

    if (!hasInternetConnection || isCancelLogin) {
      await this.setOffline();
      return;
    }

    await this.setPreviousUserDesktopMode();
  }

  private async setPreviousUserDesktopMode() {
    const appInfo: AppInfoSchema = await lastValueFrom(this.appInfoDbService.get());
    const userWasConnected = appInfo.currentNetworkMode;

    if (userWasConnected) {
      await this.setOnline();
    } else {
      await this.setOffline();
    }
  }

  private async setOffline() {
    this.authService.isOffline.set(true);
    await this.networkStatusService.switchOfflineMode();
  }

  private async setOnline() {
    this.authService.isOffline.set(false);
    await this.networkStatusService.switchOnlineMode();
  }
}
